import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'stylesheets/discover.scss'

import Vue from 'vue'
import VueMask from 'v-mask'
import VueAxios from 'vue-axios'

import VueScreen from 'vue-screen'
import { InlineSvgPlugin } from 'vue-inline-svg'
import * as Sentry from '@sentry/vue'

import App from '~app/discover.vue' // TODO: content of this

import axios from '~plugins/axios'
import store from '~store/flightvoucher/store'
import i18nBuilder from '~plugins/i18n'
import setErrorHandling from '~plugins/error'
import { setBrand } from '~utils/brand-provider'
import Utilities from '~mixins/utilities'
import useFormatCurrencyFilter from '~filters/format-currency'
import router from '~routes/flightvoucher/router-4y'
import I18nTo from '~plugins/I18n-to'

const brandName = 'discover'

Vue.use(InlineSvgPlugin)
Vue.use(VueScreen, 'tailwind')
Vue.use(VueMask)
Vue.use(VueAxios, axios)
Vue.use(I18nTo, { defaultLocale: 'en' })
setBrand(brandName)

Vue.mixin(Utilities)

const i18n = i18nBuilder(brandName, store)

setErrorHandling()
Sentry.setTag('brand', brandName)
Sentry.setTag('locale', i18n.locale)
useFormatCurrencyFilter(i18n)

const [subdomain] = window.location.hostname.split('.')
axios.defaults.headers.common['X-FE-Subdomain'] = subdomain

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: (h) => h(App),
    router,
    i18n,
    store,
  }).$mount()

  document.body.appendChild(app.$el)
})
